/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Link,
  Typography,
} from '@mui/material';
import {openUrl} from '@jobseeker/common-core/utils';
import {getUrlWithRefcode} from './utils';
import {jobfeedService} from '@jobseeker/common-core/services';
import {Image} from '@jobseeker/lotus/components/Image';

export const fetBlogData = async (category?: any) => {
  const resp = await jobfeedService.getLatestBlogs(category);
  return resp;
};

export const BlogMiddleBannerHP = (blogs: any) => {
  const BlogCard = (item: any) => {
    return (
      <Link
        href={getUrlWithRefcode(item.link, 'home-page')}
        target="_blank"
        underline="none"
        onClick={e => {
          e.preventDefault();
          const url = getUrlWithRefcode(item.link, 'home-page');
          setTimeout(() => openUrl(url, '_blank'), 0);
        }}
      >
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '0 0 310px',
            backgroundColor: '#fff',
            height: '280px',
            width: {xxs: 250, md: '308px', xxl: '308px'},
            maxWidth: '500px',
            marginRight: '20px',
            borderRadius: '15px',
            border: 'solid 1px #eee',
            '@media (max-width: 720px)': {
              flex: '0 0 250px',
              marginBottom: '20px',
            },
          }}
        >
          <CardMedia
            component={'img'}
            height="180"
            image={item.featuredImage}
            alt={item.title}
            sx={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              cursor: 'pointer',
              objectFit: 'cover',
              width: {xxs: 250, md: '308px', xxl: 'auto'},
            }}
          />
          <CardContent
            sx={{
              maxHeight: '95px',
              overflow: 'hidden',
              height: '100px',
              cursor: 'pointer',
              padding: '17px 16px 29px 16px',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Nunito Sans',
                fontSize: '16px',
                fontWeight: 'bold',
                lineHeight: 'normal',
                color: '#000',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {item.title}
            </Typography>
          </CardContent>
        </Card>
      </Link>
    );
  };

  return (
    <Box
      sx={{
        height: '525px',
        padding: '42px 0px 65px 20px',
        '@media (max-width: 720px)': {
          paddingLeft: {xxs: 3, md: '0px'},
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '17px',
          paddingRight: '58px',
          '@media (max-width: 720px)': {
            paddingRight: '0px',
          },
        }}
      >
        <Link
          href={getUrlWithRefcode('/blog/', 'home-page')}
          target="_blank"
          underline="none"
          onClick={e => {
            e.preventDefault();
            const url = getUrlWithRefcode('/blog/', 'home-page');
            setTimeout(() => openUrl(url, '_blank'), 0);
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontFamily: 'Nunito Sans',
              fontSize: '32px',
              color: 'rgba(0, 0, 0, .8)',
              fontWeight: 300,
              '& .blogHeaderBolder': {
                fontWeight: 'bold',
              },
            }}
          >
            Trending <span className="blogHeaderBolder">Blogs</span>
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          overflowX: 'auto',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: {xxs: 'default', md: 'default'},
          marginBottom: '42px',
          paddingLeft: {xxs: 0, md: 7},
        }}
      >
        {blogs.blogs &&
          Object.values(blogs.blogs)
            .slice(0, 4)
            .map((item, index) =>
              typeof item === 'object' && item !== null ? (
                <BlogCard key={index} {...item} />
              ) : null
            )}
      </Box>
    </Box>
  );
};
